import React from 'react';
import {BadgeType} from "./BadgeTypes";

const Badge = (props: BadgeType) => {
	return (
		<div
			className={`badge rounded 
				${!props.count ? 'notification-badge' : ''}
				${props.bigBadge ? 'big-badge' : ''}
				${props.colour ? props.colour : ''}
				${props.placement ? `floating ${props.placement}` : ''} 
			`}
			title={props.description}
		>
			{props.countLimit && props.count ? (
				<>
					{props.count > props.countLimit ? `${props.countLimit}+`: props.count}
				</>
			) : props.count ? (
				<>
					{props.count}
				</>
			) : <></>}

		</div>
	);
};

export default Badge;
